import type { AllLoadedEventHandler, PubSubEvent } from "./types";

const allLoadedEventSet = new Map<string, AllLoadedEventHandler>();

const pubsub = {
  publish(event: PubSubEvent) {
    const eventName = event.type;
    switch (eventName) {
      case "ALL_LOADED":
        allLoadedEventSet.forEach((listener) => listener());
        break;
      case "MESSAGE":
        // TODO: 구현
        break;
    }
  },

  subscribe(
    eventName: PubSubEvent["type"],
    listenerName: string,
    listener: AllLoadedEventHandler
  ) {
    switch (eventName) {
      case "ALL_LOADED":
        allLoadedEventSet.set(listenerName, listener);
        break;
      case "MESSAGE":
        // TODO: 구현
        break;
    }
  },

  unsubscribe(eventName: PubSubEvent["type"], listenerName: string) {
    switch (eventName) {
      case "ALL_LOADED":
        allLoadedEventSet.delete(listenerName);
        break;
      case "MESSAGE":
        // TODO: 구현
        break;
    }
  },
};

export default pubsub;
